// extracted by mini-css-extract-plugin
export var lg = "_1h-4";
export var md = "_1h-3";
export var sm = "_1h-2";
export var xs = "_1h-1";
export var xxs = "_1h-0";